/** Configuration navigation panel — source unique pour le menu latéral. */
export type PanelNavItemConfig = {
  to: string;
  label: string;
  section: string;
  defaultAccess: (roleId: number) => boolean;
  activePrefix?: string;
};
export type PanelNavGroupConfig = {
  id: string;
  label: string;
  items: PanelNavItemConfig[];
};
export type PanelSalonConfig = {
  id: string;
  label: string;
  subtitle: string;
  to: string;
  section: string;
  accent: 'amber' | 'sky' | 'yellow' | 'violet' | 'cyan';
  defaultAccess: (roleId: number) => boolean;
  loadingFallback: (roleId: number) => boolean;
};
export const PANEL_NAV_GROUPS: PanelNavGroupConfig[] = [
  {
    id: 'overview',
    label: "Vue d'ensemble",
    items: [
      {
        to: '/panel/dashboard',
        label: 'Dashboard',
        section: 'stats',
        defaultAccess: (r) => r >= 1 && r <= 4,
        activePrefix: '/panel/dashboard',
      },
    ],
  },
  {
    id: 'cta-scenarios',
    label: 'CTA & Scénarios',
    items: [
      {
        to: '/panel/interventions/manage',
        label: 'Gérer les scénarios',
        section: 'interventions_manage',
        defaultAccess: (r) => r >= 1 && r <= 4,
        activePrefix: '/panel/interventions',
      },
      {
        to: '/panel/interventions/create',
        label: 'Créer un scénario',
        section: 'interventions_manage',
        defaultAccess: (r) => r >= 1 && r <= 4,
        activePrefix: '/panel/interventions/create',
      },
      {
        to: '/panel/cta/categories-mission',
        label: 'Catégories mission',
        section: 'interventions_manage',
        defaultAccess: (r) => r >= 1 && r <= 4,
        activePrefix: '/panel/cta/categories-mission',
      },
    ],
  },
];
export const PANEL_SALONS: PanelSalonConfig[] = [
  {
    id: 'cm',
    label: 'CM',
    subtitle: 'Tout le panel + système',
    to: '/panel/cm',
    section: 'salon_cm',
    accent: 'amber',
    defaultAccess: (r) => r === 1,
    loadingFallback: (r) => r === 1,
  },
  {
    id: 'admin',
    label: 'Administrateur',
    subtitle: 'Joueurs & statut premium (outil staff)',
    to: '/panel/admin',
    section: 'salon_admin',
    accent: 'sky',
    defaultAccess: (r) => r === 1 || r === 2,
    loadingFallback: (r) => r === 1 || r === 2,
  },
  {
    id: 'modo',
    label: 'Modérateur',
    subtitle: 'Surveillance & modération',
    to: '/panel/modo',
    section: 'salon_modo',
    accent: 'yellow',
    defaultAccess: (r) => r === 1 || r === 3,
    loadingFallback: (r) => r === 1 || r === 3,
  },
  {
    id: 'gr-scenarios',
    label: 'GR — Scénarios',
    subtitle: 'CTA, scénarios & missions (Groupe de réflexion)',
    to: '/panel/scenariste',
    section: 'salon_scenariste',
    accent: 'violet',
    defaultAccess: (r) => r === 1 || r === 4,
    loadingFallback: (r) => r === 1 || r === 4,
  },
  {
    id: 'referents',
    label: 'Référents',
    subtitle: 'Fonctions référent assignées',
    to: '/panel/ref',
    section: 'salon_ref',
    accent: 'cyan',
    defaultAccess: (r) => r === 4,
    loadingFallback: (r) => r === 4,
  },
];
export const ROLE_LABELS: Record<number, string> = {
  1: 'Community Manager',
  2: 'Administrateur',
  3: 'Modérateur',
  4: 'Groupe de réflexion',
  5: 'Créateur de contenu',
  6: 'Joueur',
};
export function resolvePageTitle(pathname: string): string {
  if (pathname.startsWith('/panel/cm/maintenance')) return 'Maintenance';
  if (pathname.startsWith('/panel/cm/referent')) return 'Référent CM';
  if (pathname.startsWith('/panel/cm')) return 'Espace CM';
  if (pathname.startsWith('/panel/admin')) return 'Espace administrateur';
  if (pathname.startsWith('/panel/modo')) return 'Espace modérateur';
  if (pathname.startsWith('/panel/scenariste')) return 'Espace GR — scénarios';
  if (pathname.startsWith('/panel/ref')) return 'Espace référent';
  if (pathname.startsWith('/panel/dashboard') || pathname === '/panel') return 'Dashboard';
  if (pathname.startsWith('/panel/players/premium')) return 'Statut premium (joueurs)';
  if (pathname.startsWith('/panel/support/team')) return 'Tickets équipe';
  if (pathname.startsWith('/panel/users/roles')) return 'Rôles utilisateurs';
  if (pathname.startsWith('/panel/users-roles')) return 'Liste & comptes';
  if (pathname.startsWith('/panel/roles/default-access')) return 'Accès par défaut (rôles)';
  if (pathname.startsWith('/panel/roles/individual')) return 'Rôles individuels';
  if (pathname === '/panel/users' || pathname.startsWith('/panel/users/')) return 'Utilisateurs (détail)';
  if (pathname.startsWith('/panel/moderation/manage')) return 'Gestion joueur';
  if (pathname.startsWith('/panel/moderation')) return 'Modération';
  if (pathname.startsWith('/panel/interventions/create')) return 'Créer un scénario';
  if (pathname.startsWith('/panel/interventions/manage')) return 'Gérer les scénarios';
  if (pathname.startsWith('/panel/interventions/edit')) return 'Modifier scénario';
  if (pathname.startsWith('/panel/cta/categories-mission')) return 'Catégories mission';
  if (pathname.startsWith('/panel/cta')) return 'CTA — interventions';
  if (pathname.startsWith('/panel/system/security-logs')) return 'Logs sécurité (complet)';
  if (pathname.startsWith('/panel/system/backup')) return 'Sauvegardes';
  if (pathname.startsWith('/panel/security')) return 'Logs & traçabilité';
  if (pathname.startsWith('/panel/config')) return 'Configuration métier';
  return 'Panel';
}
